// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jua&family=Noto+Sans+KR:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 여권 판매 부스 - 로그인 페이지 스타일
 * VIP 퍼플 테마
 */

.login-page {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  background: linear-gradient(170deg, #F3E5F5 0%, #FFF8E1 50%, #F8F4E8 100%);
  position: relative;
  overflow: hidden;
}

/* 배경 장식 요소 */
.login-page::before {
  content: '';
  position: absolute;
  top: -80px;
  right: -80px;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(123, 31, 162, 0.12) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.login-page::after {
  content: '';
  position: absolute;
  bottom: -60px;
  left: -60px;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(212, 175, 55, 0.12) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

/* 떠다니는 장식 */
.login-deco {
  position: absolute;
  font-size: 48px;
  opacity: 0.2;
  animation: floatDeco 6s ease-in-out infinite;
  pointer-events: none;
  z-index: 0;
}

.login-deco:nth-child(1) {
  top: 8%;
  left: 8%;
  animation-delay: 0s;
}

.login-deco:nth-child(2) {
  top: 15%;
  right: 12%;
  animation-delay: -2s;
  font-size: 36px;
}

.login-deco:nth-child(3) {
  bottom: 20%;
  left: 15%;
  animation-delay: -4s;
  font-size: 42px;
}

.login-deco:nth-child(4) {
  bottom: 12%;
  right: 10%;
  animation-delay: -1s;
  font-size: 52px;
}

@keyframes floatDeco {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-12px) rotate(5deg);
  }
}

/* 메인 컨텐츠 */
.login-content {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 48px;
  padding: 20px 40px;
  z-index: 1;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 로고 영역 */
.login-logo {
  text-align: center;
  margin-bottom: 0;
}

.login-logo-emoji {
  font-size: 64px;
  display: block;
  margin-bottom: 10px;
  animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

.login-logo h1 {
  font-family: 'Jua', sans-serif;
  font-size: 48px;
  color: #7B1FA2;
  margin: 0;
  letter-spacing: 2px;
}

.login-logo-sub {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 20px;
  color: #9C27B0;
  margin-top: 6px;
  font-weight: 500;
  letter-spacing: 4px;
}

/* 카드 */
.login-card {
  width: 100%;
  max-width: 420px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 28px 32px;
  box-shadow:
    0 8px 32px rgba(123, 31, 162, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.06);
  border: 2px solid rgba(123, 31, 162, 0.1);
}

/* 입력 폼 */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.login-input-group {
  position: relative;
}

.login-input-icon {
  position: absolute;
  left: 22px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  opacity: 0.5;
  pointer-events: none;
}

.login-input {
  width: 100%;
  padding: 16px 16px 16px 52px;
  font-size: 20px;
  font-family: 'Noto Sans KR', sans-serif;
  border: 3px solid #E1BEE7;
  border-radius: 16px;
  background: #FDF5FF;
  outline: none;
  transition: border-color 0.25s, box-shadow 0.25s, background-color 0.25s;
  color: #2D1B4E;
  box-sizing: border-box;
}

.login-input::placeholder {
  color: #CE93D8;
  font-size: 20px;
}

.login-input:focus {
  border-color: #7B1FA2;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(123, 31, 162, 0.12);
}

/* 에러 메시지 */
.login-error {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  background: #fff5f5;
  border: 2px solid #ffc9c9;
  border-radius: 14px;
  animation: shake 0.3s ease;
}

.login-error-icon {
  font-size: 22px;
  flex-shrink: 0;
}

.login-error p {
  margin: 0;
  font-size: 18px;
  font-family: 'Noto Sans KR', sans-serif;
  color: #c92a2a;
  font-weight: 500;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-6px); }
  75% { transform: translateX(6px); }
}

/* 로그인 버튼 */
.login-btn {
  width: 100%;
  padding: 16px;
  font-size: 22px;
  font-family: 'Jua', sans-serif;
  font-weight: 400;
  letter-spacing: 3px;
  color: #fff;
  background: linear-gradient(135deg, #7B1FA2, #9C27B0);
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s, opacity 0.2s;
  box-shadow: 0 4px 16px rgba(123, 31, 162, 0.3);
  margin-top: 2px;
  min-height: auto;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(123, 31, 162, 0.4);
}

.login-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(123, 31, 162, 0.2);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 로딩 스피너 */
.login-btn-loading {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.login-spinner {
  display: inline-block;
  width: 22px;
  height: 22px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 하단 장식 */
.login-footer-deco {
  text-align: center;
  margin-top: 16px;
  font-size: 13px;
  font-family: 'Noto Sans KR', sans-serif;
  color: #B39DDB;
  letter-spacing: 1px;
}

.login-logo-char {
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 50%;
  display: block;
  margin: 0 auto 10px;
  animation: bounce 2s ease-in-out infinite;
  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.2));
}

.login-footer-characters {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 6px;
}

.footer-char {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50%;
  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.15));
}

.login-footer-animals {
  font-size: 24px;
  letter-spacing: 6px;
  margin-bottom: 4px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAIF;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,4CAA4C;EAC5C,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA,WAAW;AACX;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,OAAO;AACP;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB;;iCAE+B;EAC/B,yCAAyC;AAC3C;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,uCAAuC;EACvC,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,wEAAwE;EACxE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,uCAAuC;EACvC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,WAAW;AACX;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,2DAA2D;EAC3D,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["/**\n * 여권 판매 부스 - 로그인 페이지 스타일\n * VIP 퍼플 테마\n */\n\n@import url('https://fonts.googleapis.com/css2?family=Jua&family=Noto+Sans+KR:wght@400;500;700&display=swap');\n\n.login-page {\n  display: flex;\n  flex-direction: column;\n  height: 100dvh;\n  background: linear-gradient(170deg, #F3E5F5 0%, #FFF8E1 50%, #F8F4E8 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n/* 배경 장식 요소 */\n.login-page::before {\n  content: '';\n  position: absolute;\n  top: -80px;\n  right: -80px;\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(circle, rgba(123, 31, 162, 0.12) 0%, transparent 70%);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.login-page::after {\n  content: '';\n  position: absolute;\n  bottom: -60px;\n  left: -60px;\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(circle, rgba(212, 175, 55, 0.12) 0%, transparent 70%);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n/* 떠다니는 장식 */\n.login-deco {\n  position: absolute;\n  font-size: 48px;\n  opacity: 0.2;\n  animation: floatDeco 6s ease-in-out infinite;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.login-deco:nth-child(1) {\n  top: 8%;\n  left: 8%;\n  animation-delay: 0s;\n}\n\n.login-deco:nth-child(2) {\n  top: 15%;\n  right: 12%;\n  animation-delay: -2s;\n  font-size: 36px;\n}\n\n.login-deco:nth-child(3) {\n  bottom: 20%;\n  left: 15%;\n  animation-delay: -4s;\n  font-size: 42px;\n}\n\n.login-deco:nth-child(4) {\n  bottom: 12%;\n  right: 10%;\n  animation-delay: -1s;\n  font-size: 52px;\n}\n\n@keyframes floatDeco {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-12px) rotate(5deg);\n  }\n}\n\n/* 메인 컨텐츠 */\n.login-content {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 48px;\n  padding: 20px 40px;\n  z-index: 1;\n  animation: fadeInUp 0.6s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* 로고 영역 */\n.login-logo {\n  text-align: center;\n  margin-bottom: 0;\n}\n\n.login-logo-emoji {\n  font-size: 64px;\n  display: block;\n  margin-bottom: 10px;\n  animation: bounce 2s ease-in-out infinite;\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-8px);\n  }\n}\n\n.login-logo h1 {\n  font-family: 'Jua', sans-serif;\n  font-size: 48px;\n  color: #7B1FA2;\n  margin: 0;\n  letter-spacing: 2px;\n}\n\n.login-logo-sub {\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 20px;\n  color: #9C27B0;\n  margin-top: 6px;\n  font-weight: 500;\n  letter-spacing: 4px;\n}\n\n/* 카드 */\n.login-card {\n  width: 100%;\n  max-width: 420px;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(12px);\n  border-radius: 20px;\n  padding: 28px 32px;\n  box-shadow:\n    0 8px 32px rgba(123, 31, 162, 0.12),\n    0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 2px solid rgba(123, 31, 162, 0.1);\n}\n\n/* 입력 폼 */\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.login-input-group {\n  position: relative;\n}\n\n.login-input-icon {\n  position: absolute;\n  left: 22px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 24px;\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.login-input {\n  width: 100%;\n  padding: 16px 16px 16px 52px;\n  font-size: 20px;\n  font-family: 'Noto Sans KR', sans-serif;\n  border: 3px solid #E1BEE7;\n  border-radius: 16px;\n  background: #FDF5FF;\n  outline: none;\n  transition: border-color 0.25s, box-shadow 0.25s, background-color 0.25s;\n  color: #2D1B4E;\n  box-sizing: border-box;\n}\n\n.login-input::placeholder {\n  color: #CE93D8;\n  font-size: 20px;\n}\n\n.login-input:focus {\n  border-color: #7B1FA2;\n  background: #fff;\n  box-shadow: 0 0 0 4px rgba(123, 31, 162, 0.12);\n}\n\n/* 에러 메시지 */\n.login-error {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 20px;\n  background: #fff5f5;\n  border: 2px solid #ffc9c9;\n  border-radius: 14px;\n  animation: shake 0.3s ease;\n}\n\n.login-error-icon {\n  font-size: 22px;\n  flex-shrink: 0;\n}\n\n.login-error p {\n  margin: 0;\n  font-size: 18px;\n  font-family: 'Noto Sans KR', sans-serif;\n  color: #c92a2a;\n  font-weight: 500;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-6px); }\n  75% { transform: translateX(6px); }\n}\n\n/* 로그인 버튼 */\n.login-btn {\n  width: 100%;\n  padding: 16px;\n  font-size: 22px;\n  font-family: 'Jua', sans-serif;\n  font-weight: 400;\n  letter-spacing: 3px;\n  color: #fff;\n  background: linear-gradient(135deg, #7B1FA2, #9C27B0);\n  border: none;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: transform 0.15s, box-shadow 0.15s, opacity 0.2s;\n  box-shadow: 0 4px 16px rgba(123, 31, 162, 0.3);\n  margin-top: 2px;\n  min-height: auto;\n}\n\n.login-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(123, 31, 162, 0.4);\n}\n\n.login-btn:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(123, 31, 162, 0.2);\n}\n\n.login-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* 로딩 스피너 */\n.login-btn-loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.login-spinner {\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* 하단 장식 */\n.login-footer-deco {\n  text-align: center;\n  margin-top: 16px;\n  font-size: 13px;\n  font-family: 'Noto Sans KR', sans-serif;\n  color: #B39DDB;\n  letter-spacing: 1px;\n}\n\n.login-logo-char {\n  width: 96px;\n  height: 96px;\n  object-fit: cover;\n  border-radius: 50%;\n  display: block;\n  margin: 0 auto 10px;\n  animation: bounce 2s ease-in-out infinite;\n  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.2));\n}\n\n.login-footer-characters {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.footer-char {\n  width: 32px;\n  height: 32px;\n  object-fit: cover;\n  border-radius: 50%;\n  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.15));\n}\n\n.login-footer-animals {\n  font-size: 24px;\n  letter-spacing: 6px;\n  margin-bottom: 4px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
